import ChatboxPage from './ChatboxPage';

export default ChatboxPage;
